import { Navigate } from "react-router-dom";
import { useAuth } from "../AuthProvider";
import { toast } from "sonner";

const PrivateRoute = ({ element }) => {
  const { user, setPageError } = useAuth();

  // check user permission depending if they can view the page, page permission is just the url name, lets also change it to lowercase to ensure it matches
  const currentUrl = window.location.pathname.toLowerCase();

  console.log('currentUrl', currentUrl);

  // check if user is logged in
  if (!user) {
    setPageError("You need to login to view this page");
    return <Navigate to="/login" />;
  }

  // check if the user has permission to view the page
  const permission = user.role_permissions.find(
    (permission) => permission.screen_name.toLowerCase() === currentUrl
  );

  console.log('permission', permission);

  if (!permission && currentUrl !== "/") {
    setPageError("You do not have permission to view this page");
    return <Navigate to="/Dashboard" />;
  }

  if (currentUrl === "/") {
    return user ? <Navigate to="/Dashboard" /> : <Navigate to="/login" />;
  }

  return user ? element : <Navigate to="/login" />;
};

export default PrivateRoute;
